<template>
  <div class="content">

  </div>
</template>
<script>
import { getOpenId, getOrganizationByOpenId } from '../../api';
export default {
  name: 'template',
  data() {
    return {
      wxConfig: {
        appid: "wx9fc68a7bac8f1258",
        url: location.href.split('#').toString()
      }
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    getOrganizationByOpenId(openId) {
      var that = this;
      getOrganizationByOpenId("?openId=" + openId).then(function (result) {
        if (result.code == 1) {
          if (result.data.id == null || result.data.id == "") {
            // 没有绑定信息，跳转绑定页面
            that.$router.push("/bind");
          } else {
            // 有绑定信息，继续
            var loginBackcallUrl = sessionStorage.getItem('loginBackcallUrl');
            sessionStorage.setItem('token', result.data.token);
            that.$router.push(loginBackcallUrl);
          }
        } else {
          that.$toast(result.message)
        }
      });
    }
  },
  mounted() {
    var that = this;
    if (that.getQueryString("code") == null || that.getQueryString("code") == "") {
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.wxConfig.appid + "&" + "redirect_uri=" + encodeURIComponent(that.wxConfig.url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      window.location.href = url;
    } else {
      getOpenId("?code=" + that.getQueryString("code")).then(function (res) {
        if (res.code == 1) {
          sessionStorage.setItem('weixinInfo', res.data);
          sessionStorage.setItem('openId', res.data.openid);
          that.getOrganizationByOpenId(res.data.openid);
        } else {
          that.$toast(res.message)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/login/index.vue


// WEBPACK FOOTER //
// src/views/login/index.vue